import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	otherEnvironments: {
		id: 'software-deployments.timeline.deployments-bar.circles.environments-label.other-environments',
		defaultMessage:
			'+ {otherEnvironmentsCount} {otherEnvironmentsCount, plural, one {other} other {others}} ',
		description:
			'Label that indicates how many different environments were deployed to in a group of deployments.',
	},
});
